import { render, staticRenderFns } from "./OleMiss116Lab2ReportSheet.vue?vue&type=template&id=776e8f5e&"
import script from "./OleMiss116Lab2ReportSheet.vue?vue&type=script&lang=js&"
export * from "./OleMiss116Lab2ReportSheet.vue?vue&type=script&lang=js&"
import style0 from "./OleMiss116Lab2ReportSheet.vue?vue&type=style&index=0&id=776e8f5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VRow,VSimpleTable})
